import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import ModInfo from "./ModInfo";
import { useIntl } from "react-intl";

interface ModOrderDetailProps {
 controller?: Record<string,any>;
 hideCallback?: () => void;
 open?: boolean;
 orderId?: number;
}

const DEFAULT_PROPS = {
  controller: null,
  hideCallback: () => {},
  open: false,
  orderId: null,
}

const ModOrderDetail = (propsParam: ModOrderDetailProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  const intl = useIntl();
  const isMounted = useRef(true);

  const [detail, setDetail] = useState("");
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const refresh = async () => {
      setIsLoading(true)
      const [
        response,
        error,
        network,
      ] = await props.controller.getDoctorOrderDetail(props.orderId);
      setIsLoading(false)
      if (isMounted.current) {
        if (error) {
          toast.error(error);
        } else {
          setDetail(
            <div
              dangerouslySetInnerHTML={{
                __html: response.order_detail,
              }}
            /> as any
          );
        }
      }
    };

    if (props.orderId) {
      refresh();
    }
  }, [props.orderId]);

  useEffect(() => {
    if(!props.open){
      setDetail("")
    }
  }, [props.open])

  return (
    <ModInfo
      btnLoading={isLoading}
      open={!!props.open}
      titleColor="darkblue"
      buttonColor="blue"
      titleName={intl.formatMessage({ id: "รายละเอียด" })}
      alertText={detail}
      btnText={intl.formatMessage({ id: "ปิด" })}
      onApprove={props.hideCallback}
      onClose={props.hideCallback}
    />
  );
};


export default React.memo(ModOrderDetail);
